import React, { useState } from 'react'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import QuizIcon from '@mui/icons-material/Quiz'
import Tooltip from '@mui/material/Tooltip'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import NumberFormat from 'react-number-format'
import '../../../../Styles/App/Pay/Pay.css'
import CardPayGuias from './CardPayGuias'
let QrCodeAPI =
	'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'
const Codi = ({ QrCodeAPI }) => (
	<img
		style={{ width: '350px', height: '' }}
		src={`data:image/jpeg;base64,${QrCodeAPI}`}
		alt=''
	/>
)
const PayGuias = (props) => {
	//Estados visibilidad metodos de pago
	const [card, setCard] = useState(false)

	//estados del toggle btn
	const [alignment, setAlignment] = useState('Card')

	const handleCardView = (event, newAlignment) => {
		setAlignment(newAlignment)
		setCard(!card)
	}
	const [viewInfo, setViewInfo] = useState(false)
	const handleviewInfo = () => {
		setViewInfo(!viewInfo)
	}
	const handleBack = () => {
		props.handleBack()
	}

	return (
		<>
			<div className='flex-column mb5'>
				<ToggleButtonGroup
					color='primary'
					value={alignment}
					exclusive
					onChange={handleCardView}
					aria-label='Platform'
					className='w80'
				>
					<ToggleButton
						className='w50'
						value='Card'
						endIcon={<CreditCardIcon />}
					>
						Debito, Credito, Mastercard
					</ToggleButton>
					<ToggleButton
						className='w50'
						value='Transfer'
						endIcon={<QrCodeScannerIcon />}
					>
						Pagos Mediante CODI
					</ToggleButton>
				</ToggleButtonGroup>

				<div className='boxDetailPurchase'>
					<Button
						className='btn-change-amount'
						startIcon={<ChevronLeftIcon />}
						onClick={handleBack}
					>
						Cambiar Monto
					</Button>
					<div className='flex mt1'>
						{/* <strong>TBolso Book Tote Bag</strong> */}
						<p className='w80'>
                            Tipo de envío:  {' '}
							<strong>
                            Express Domestic
							</strong>
						</p>
						<p className='w20'>
							<NumberFormat
								value='250'
								displayType={'text'}
								fixedDecimalScale={true}
								decimalScale={2}
								thousandSeparator={true}
								prefix={'$ '}
								suffix={' MXN'}
							/>
						</p>
					</div>
					<div className='flex'>
						<p className='w80'>Cargo por servicio</p>
						<p className='w20'>
							<NumberFormat
								value={(250) * 0.03 + 3}
								displayType={'text'}
								fixedDecimalScale={true}
								decimalScale={2}
								thousandSeparator={true}
								prefix={'$ '}
								suffix={' MXN'}
							/>
						</p>
					</div>
					<div className='flex border-top mt2'>
						<p className='w80'>Total a pagar</p>
						<p className='w20'>
							<NumberFormat
								value={
									250 +
									(250) * 0.03 +
									3
								}
								displayType={'text'}
								fixedDecimalScale={true}
								decimalScale={2}
								thousandSeparator={true}
								prefix={'$ '}
								suffix={' MXN'}
							/>
						</p>
					</div>
				</div>
			</div>

			{card === false ? (
				<CardPayGuias props={props} />
			) : (
				<>
					<div className='flex'>
						<p className='fs30 text-center bold'>
							Escanea el siguiente codigo QR
						</p>

						<Tooltip title='Tutorial' placement='right'>
							<IconButton
								aria-label='Tutorial'
								className='btn-inf-codi'
								onClick={handleviewInfo}
							>
								<QuizIcon className='icon-inf-codi' />
							</IconButton>
						</Tooltip>
					</div>
					{viewInfo === false ? (
						<div className='flex'>
							<Codi QrCodeAPI={QrCodeAPI} />
						</div>
					) : (
						<div className=' center w80'>
							<p>
								<strong>1: Inicia la app móvil: </strong>Inicia la app móvil de
								tu institución financiera¹.
							</p>
							<p>
								<strong>2: Únete a CoDi®: </strong>Localiza la sección de CoDi®
								en tu app móvil y enrólate.
							</p>
							<p>
								<strong>3: Escanea un CoDi®: </strong>Pide a la persona o
								comercio que te genere un CoDi para poder pagar.
							</p>
							<p>
								<strong>4: Realiza tu pago: </strong>Busca la opción pagar con
								CoDi® y acerca tu teléfono (vía QR o NFC²) al QR del comercio o
								de la persona que te va a cobrar el bien o servicio. Escanea el
								código.
							</p>
							<p>
								<strong>5: Verificar los datos de la operación: </strong>Revisa
								los datos del cobro, entre ellos, el nombre del receptor del
								pago, el monto y el concepto del pago.
							</p>
							<p>
								<strong>6: Autoriza el pago: </strong>Algunas instituciones
								financieras solicitan un factor de autenticación para autorizar
								el pago, el cual puede ser tu nip, tu huella, tu rostro o un
								token.
							</p>
							<p>
								<strong>7: Confirma tu pago: </strong>Tú y el vendedor (comercio
								o persona que te cobro el bien o servicio) recibirán una
								notificación en sus dispositivos móviles para confirmar que el
								dinero se encuentra disponible en la cuenta del vendedor.
							</p>
						</div>
					)}
				</>
			)}

			{/* <div>
				<Button className='btn-pay' onClick={handleBack}>
					Cambiar monto
				</Button>
			</div> */}
		</>
	)
}
export default PayGuias